<div class="login-screen">
  <div class="login-box" *ngIf="!redirecting" [@fadeIn]>
    <h2>{{ 'login.title' | translate }}</h2>
    <div class="d-flex ctas">
      <button type="button" nglButton variant="outline-brand" iconName="utility:user" (click)="login()">
        {{ 'login.loginBtnText' | translate }}
      </button>
    </div>
  </div>
  <h1 *ngIf="redirecting">{{ 'login.loadingText' | translate }}</h1>
</div>
<div class="back-overlay"></div>
